 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {commitMutation} from 'react-relay'
import makeEmptyStr from '~/utils/draftjs/makeEmptyStr'
import addNodeToArray from '~/utils/relay/addNodeToArray'
import createProxyRecord from '~/utils/relay/createProxyRecord'



import getDiscussionThreadConn from './connections/getDiscussionThreadConn'
import safePutNodeInConn from './handlers/safePutNodeInConn'

graphql`
  fragment AddCommentMutation_meeting on AddCommentSuccess {
    comment {
      ...ThreadedItem_threadable
      discussionId
      threadSortOrder
      threadParentId
    }
    meetingId
  }
`

const mutation = graphql`
  mutation AddCommentMutation($comment: AddCommentInput!) {
    addComment(comment: $comment) {
      ... on ErrorPayload {
        error {
          message
        }
      }
      ...AddCommentMutation_meeting @relay(mask: false)
    }
  }
`

export const addCommentMeetingUpdater = (
  payload,
  {store}
) => {
  const meetingId = payload.getValue('meetingId')
  const meeting = store.get(meetingId)
  const isRightDrawerOpen = _optionalChain([meeting, 'optionalAccess', _ => _.getValue, 'call', _2 => _2('isRightDrawerOpen')])
  if (isRightDrawerOpen === false) {
    _optionalChain([meeting, 'optionalAccess', _3 => _3.setValue, 'call', _4 => _4(true, 'isCommentUnread')])
  }
  const comment = payload.getLinkedRecord('comment')
  if (!comment) return
  const threadParentId = comment.getValue('threadParentId')
  if (threadParentId) {
    addNodeToArray(comment, store.get(threadParentId), 'replies', 'threadSortOrder')
    return
  }
  const discussionId = comment.getValue('discussionId')
  if (discussionId) {
    const threadConn = getDiscussionThreadConn(store, discussionId)
    safePutNodeInConn(threadConn, comment, store, 'threadSortOrder', true)
    const discussion = store.get(discussionId)
    if (discussion) {
      discussion.setValue((discussion.getValue('commentCount') ) + 1, 'commentCount')
    }
  }
}

const AddCommentMutation = (
  atmosphere,
  variables,
  {onError, onCompleted}
) => {
  return commitMutation(atmosphere, {
    mutation,
    variables,
    updater: (store) => {
      const payload = store.getRootField('addComment')
      addCommentMeetingUpdater(payload , {atmosphere, store})
    },
    optimisticUpdater: (store) => {
      const {viewerId} = atmosphere
      const {comment} = variables
      const {isAnonymous} = comment
      const now = new Date().toJSON()
      const optimisticComment = createProxyRecord(store, 'Comment', {
        ...comment,
        createdAt: now,
        updatedAt: now,
        createdBy: isAnonymous ? null : viewerId,
        comtent: comment.content || makeEmptyStr(),
        isActive: true,
        isViewerComment: true
      })
        .setLinkedRecord(store.get(viewerId), 'user')
        .setLinkedRecords([], 'reactjis')
        .setLinkedRecords([], 'replies')
      if (!isAnonymous) {
        const viewer = store.getRoot().getLinkedRecord('viewer')
        optimisticComment.setLinkedRecord(viewer, 'createdByUser')
      }
      const payload = createProxyRecord(store, 'payload', {})
      payload.setLinkedRecord(optimisticComment, 'comment')
      addCommentMeetingUpdater(payload , {atmosphere, store})
    },
    onCompleted,
    onError
  })
}

export default AddCommentMutation
